import { fetchBody } from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_TEAM_ADD, URL_TEAM_GET_LIST, URL_TEAM_GET_DETAIL, URL_TEAM_EDIT, URL_TEAM_CHECK_NAME, URL_LEAGUE_TEAM_GET_LIST, URL_GAME_SCORER_GET_LIST, URL_GAME_CHECK_NO, URL_GAME_ADD, URL_GAME_EDIT, URL_GAME_GET_LIST, URL_GAME_GET_DETAIL, GET_LAST_GAME_BOARD, URL_GAME_GET_LAST_GAME_BOARD, GET_GAME_CURRENT_ALL, GET_GAME_ACTION_LIST, GET_ACTION_LIST_BY_REQACTION, GET_ACTION_LIST_BY_REQPITCH, GET_INNING_HALF_PITCHER_LIST, GET_ALL_PLAYERS_FROM_GAME, GET_BALL_LOSS, SET_BALL_LOSS } from "../../setup/config_mystat";
import url from "socket.io-client/lib/url";

export function api_getScorerList({ companyId, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: { companyId }, token }),
      url: URL_GAME_SCORER_GET_LIST,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}


export function api_getGameList({ mReqGameList, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: mReqGameList, token }),
      url: URL_GAME_GET_LIST,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}
export function api_addGame({ isAdd = true, mRespGame, history, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: mRespGame, token }),
      url: isAdd ? URL_GAME_ADD : URL_GAME_EDIT,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}

export function api_getGameDetail({ mReqGameDetail, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: mReqGameDetail, token }),
      url: URL_GAME_GET_DETAIL,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}

export function api_checkGameNo({ game_no, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: { game_no }, token }),
      url: URL_GAME_CHECK_NO,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}

export function api_getLastGameBoard({ mReqGameDetail, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: mReqGameDetail, token }),
      url: URL_GAME_GET_LAST_GAME_BOARD,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}

export function api_getGameCurrentAll({ mReqGameDetail, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: mReqGameDetail, token }),
      url: GET_GAME_CURRENT_ALL,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}

export function api_getAllPlayersFromGame({ mReqGameDetail, success, failure }) {
  var token = getToken();
  if (token === "") {
    toLogout(false);
  } else {
    cleanFetch({
      body: fetchBody({ body: mReqGameDetail, token }),
      url: GET_ALL_PLAYERS_FROM_GAME,
      success: (jsonDate) => {
        success(jsonDate)
      },
      failure: (error) => {
        failure(error)
      }
    })
  }
}

export function api_getBallsLoss({ payload, success, failure }) {
  let token = getToken()
  if (token === "") {
    toLogout(false)
  } else {
    cleanFetch({
      body: fetchBody({ body: payload, token}),
      url: GET_BALL_LOSS,
      success: (jsonDate) => { success(jsonDate) },
      failure: (error) => { failure(error) }
    })
  }
}

export function api_setBallsLoss({ payload, success, failure }) {
  let token = getToken()
  if (token === "") {
    toLogout(false)
  } else {
    cleanFetch({
      body: fetchBody({ body: payload, token}),
      url: SET_BALL_LOSS,
      success: (jsonDate) => { success(jsonDate) },
      failure: (error) => { failure(error) }
    })
  }
}